/**
 * Centralized feature flags. Defaults below are the v1 ship state; flip
 * individual flags here when the corresponding feature graduates.
 *
 * Flags are read at module load — there is no runtime override surface.
 * Server-side flags should live in env / Supabase config; this file is
 * for client-side toggles that gate UI.
 */
export const FEATURES = {
  /**
   * SAB-288 wallet KYC threshold warning.
   *
   * Renders a "Approaching $5K — verify identity" prompt on the wallet
   * page when YTD winnings cross 90% of the IRS 1099-MISC threshold.
   * Wired in but hidden until SAB-176 (Persona KYC integration) ships.
   * Flip to true once the verify-now flow has a real destination.
   */
  bonus_kyc_warning: false as boolean,
} as const;
